<template>
     <div class="animated fadeIn">
        <b-card class="card-accent-info">
            <div slot="header">
                Preferências
                <div class="card-header-actions">                    
                    <b-link href="#" class="card-header-action btn-help">
                    <i class="icon-question" @click="openHelp('/?page=franchise/preference')"></i>
                    </b-link>                                    
                </div>
            </div>

            <!--
            <template #header>
                <div>
                    <b-row>
                    <b-col><div class="mb-0">Preferências</div></b-col>
                    <b-col>
                        <div class="mb-0 text-right">
                        <button type="button" class="btn btn-sm btn-outline-primary" @click="openHelp('/?page=franchise/preference')"><i class="fa fa-question"></i></button>
                        </div>
                    </b-col>
                    </b-row>            
                </div>
            </template>
            -->
            <b-row>
                <b-col cols="auto">
                    <b-form-group>
                        <label for="company" style="font-size: 0.8em">Empresa</label>
                        <b-form-select id="company"
                        v-model="filters.companyId"
                        :plain="true"
                        :options="companyDDL"
                        @change="changeCompany">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr>
            <h6>Taxa de Adesão e Mensalidades</h6>
            <hr>

            <b-form @submit.stop.prevent="onSubmit">
                
                <div class="animated fadeIn">
                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Taxa de Adesão"
                            label-for="membershipFee"
                            :label-cols="6"
                            :horizontal="true">
                          
                            <b-input-group>
                                <b-input-group-prepend>
                                <b-input-group-text>R$</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input v-model="preference.membershipFee" id="membershipFee" type="number"></b-form-input>
                            </b-input-group>
                            
                            </b-form-group>          
                            </b-form>
                        </b-col>

                    </b-row>

                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description="Em caso de indicação"
                            label="Comissão da Taxa de Adesão"
                            label-for="membershipFeePercentage"
                            :label-cols="6"
                            :horizontal="true">
                                <b-input-group>
                                    <b-form-input v-model="preference.membershipFeePercentage" id="membershipFeePercentage" type="number"></b-form-input>
                                    <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Mensalidade"
                            label-for="monthlyFee"
                            :label-cols="6"
                            :horizontal="true">

                            <b-input-group>
                                <b-input-group-prepend>
                                <b-input-group-text>R$</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input v-model="preference.monthlyFee" id="monthlyFee" type="number"></b-form-input>
                            
                            </b-input-group>

                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <hr>
                    <h6>Comissão</h6>
                    <hr>
                    
                    
                    

                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Clube AVO"
                            label-for="companyPerc"
                            :label-cols="6"
                            :horizontal="true">
                                <b-input-group>
                                    <b-form-input v-model="preference.companyPercentage" id="companyPerc" type="number"></b-form-input>
                                    <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Patrocinador"
                            label-for="sponsorPerc"
                            :label-cols="6"
                            :horizontal="true">
                                <b-input-group>
                                    <b-form-input v-model="preference.sponsorPercentage"  id="sponsorPerc" type="number"></b-form-input>
                                    <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
                                </b-input-group>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Indicador"
                            label-for="indicatonPerc"
                            :label-cols="6"
                            :horizontal="true">
                                <b-input-group>
                                    <b-form-input v-model="preference.indicationPercentage"  id="indicationPerc" type="number"></b-form-input>
                                    <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
                                </b-input-group>
                            </b-form-group>          
                            </b-form>
                        </b-col>


                    </b-row>

                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Dividendos / Grupo"
                            label-for="groupPerc"
                            :label-cols="6"
                            :horizontal="true">
                                <b-input-group>
                                    <b-form-input v-model="preference.groupPercentage"  id="groupPerc" type="number"></b-form-input>
                                    <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Doação"
                            label-for="donationPerc"
                            :label-cols="6"
                            :horizontal="true">
                                <b-input-group>
                                    <b-form-input v-model="preference.donationPercentage"  id="donationPerc" type="number"></b-form-input>
                                    <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
                                </b-input-group>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="4">
                            <b-form>
                            <b-form-group
                            description=""
                            label=""
                            label-for="totalPerc"
                            :label-cols="6"
                            :horizontal="true">
                               {{ totalPerc }}%
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>


                    <hr>
                    <h6>Configurações do Sistema</h6>
                    <hr>
                    
                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description="Vários destinatário podem ser separados por ponto e vírgula. Ex: email@dominio.com.br; adm@dominio.com.br"
                            label="E-mail do Administrador"
                            label-for="admMail"
                            :label-cols="2"
                            :horizontal="true">
                            <b-form-input v-model="preference.admMail" id="name" type="text" style="text-transform: lowercase" ></b-form-input>
                        </b-form-group>          
                        </b-form>
                        </b-col>
                    </b-row>

                    <hr>
                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description="Grupo de acesso padrão para novos usuários"
                            label="Grupo padrão"
                            label-for="group"
                            :label-cols="2"
                            :horizontal="true">
                            <b-row>
                                <b-col md="4">
                                    <b-form-input :value="preference.group ? preference.group.name : ''" id="group" type="text" readonly ></b-form-input>
                                </b-col>
                            </b-row>
                            
                        </b-form-group>          
                        </b-form>
                        </b-col>
                    </b-row>


                </div>
            </b-form>

             <div slot="footer" class="text-right">
                <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Preferência</span></b-button>
            </div>

        </b-card>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from "axios";
    
    import { Switch as cSwitch } from '@coreui/vue'
    
    /* Toast */
    import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
        success: 'success',
        error: 'error',
        info: 'info',
        warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
        return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
        success: toast,
        error: toast,
        info: toast,
        warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
    
    const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
    
    export default {
        name: 'tables',
        components: {
        Event,
        cSwitch
        },
        data: () => {
            return {
                preference: {},
                companyDDL: [],
                filters: {
                    companyId: null
                }
            }
        },
        computed: {
            totalPerc() {
                return parseFloat(Number(this.preference.companyPercentage ? this.preference.companyPercentage : 0)
                    + Number(this.preference.indicationPercentage ? this.preference.indicationPercentage : 0)
                    + Number(this.preference.groupPercentage ? this.preference.groupPercentage : 0)
                    + Number(this.preference.donationPercentage ? this.preference.donationPercentage : 0)
                    + Number(this.preference.sponsorPercentage ? this.preference.sponsorPercentage : 0)).toFixed(2)
            }
        },
        methods: {
            async refreshData() {
                this.isBusy = true;
        
                var s = this;
                var currentUser = this.$store.state.currentUser;
          
                await axios.get(
                    this.$store.state.ws_url + "/franchise/preference?companyId=" + this.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                ).then(function(resp) {
                    if(resp.data.obj && resp.data.obj.length > 0) {
                        s.preference = resp.data.obj[0]
                    }
                    else {
                        s.preference = []
                    }
                    
                })
                .catch(function(error) {
                    toast ({
                    type: VueNotifications.types.error,
                    title: 'Preferência',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 3000
                    })
                })
            
                this.isBusy = false;
            
            },
            
            changeCompany() {
                this.refreshData();
            },
            openHelp(url) {
                window.open(this.$store.state.config.ws_help + url, '_blank')
            },

            async save() {
                var s = this;
                var currentUser = this.$store.state.currentUser;
                var saveData = this.preference
                
                saveData["uid"] = currentUser.id
                saveData["sid"] = currentUser.sid
                
                console.log(saveData)
                await axios.post(
                    this.$store.state.ws_url + "/franchise/preference",
                    saveData
                ).then(function(resp) {
                    toast ({
                    type: VueNotifications.types.success,
                    title: 'Preferência',
                    message: 'Preferências salvas com sucesso.',
                    timeout: 3000
                    })
                    
                })
                .catch(function(error) {
                    toast ({
                    type: VueNotifications.types.error,
                    title: 'Preferência',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 3000
                    })
                })
                
            }
        },
        mounted: function() {            
            this.companyDDL = this.$store.state.currentUser.companies
            this.filters.companyId = this.$store.state.currentUser.companyId
            this.changeCompany()
        }
    }
</script>
    
<style scoped>
    table#table-transition-example .flip-list-move {
    transition: transform 1s;
    }
</style>